import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/council/$councilId/')({
	beforeLoad: async ({ params }) => {
		throw redirect({
			to: '/council/$councilId/dashboard',
			params: { councilId: params.councilId },
		});
	},
});
